'use client'
import styled, { keyframes } from 'styled-components'
import { SCREEN_SIZE } from '../../../lib/Media'

const placeholderShimmer = keyframes`
 0% {
    background-position: -468px 0;
  }
  
  100% {
    background-position: 468px 0; 
  }
`

export const StyledSimerItem = styled.span`
  margin: ${({ margin }) => margin || '0px 0px 0px 0px'};
  width: ${({ height }) => height || '100%'};
  height: ${({ text, height }) => (text ? '1rem' : height || '100%')};
  min-height: 1rem;
  min-width: 3rem;
  background: #f6f7f8;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  display: inline-block;
  position: relative;
  background-image: linear-gradient(
    to right,
    #f6f7f8 0%,
    #edeef1 20%,
    #f6f7f8 40%,
    #f6f7f8 100%
  );
  animation-duration: 1s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: ${placeholderShimmer};
  animation-timing-function: linear;
`

export const RightContainerSkeleton = styled.span`
  width: ${({ width }) => width || '100%'};
  height: ${({ height }) => height || '100%'};
  display: block;
  ${SCREEN_SIZE.Below.Tablet} {
    height: 40rem;
  }
`

export const WishListSkeleton = styled.span`
  display: flex;
  flex-direction: column;
  padding-inline: 2rem;
  width: ${({ width }) => width || '100%'};
  height: ${({ height }) => height || '100%'};
  inline-margin: 2rem;
  ${StyledSimerItem}:not(:first-child) {
    margin-top: 1rem;
  }
`

export const CartPageSkeleton = styled.span`
  display: flex;
  width: ${({ width }) => width || '100%'};
  height: ${({ height }) => height || '40rem'};
  padding: 2rem;
  ${StyledSimerItem} {
    :nth-child(1) {
      flex: 3;
    }
    :nth-child(4) {
      flex: 1;
    }
    :nth-child(2),
    :nth-child(3) {
      display: none;
    }
  }
  ${SCREEN_SIZE.Below.Tablet} {
    padding-inline: 2rem;
    height: 60rem;
    flex-direction: column;
    ${StyledSimerItem} {
      :nth-child(1),
      :nth-child(2),
      :nth-child(3) {
        display: inline-block;
        flex: 1;
        margin-top: 1rem;
      }
      :nth-child(4) {
        margin-top: 1rem;
        flex: 2;
      }
    }
  }
`

export const ProductDetailSkeleton = styled.span`
  display: flex;
  width: ${({ width }) => width || '100%'};
  height: ${({ height }) => height || '40rem'};
  ${SCREEN_SIZE.Below.MobileL} {
    padding-inline: 2rem;
    height: 60rem;
    flex-direction: column;
    ${StyledSimerItem}:last-child {
      margin-top: 1rem;
    }
  }
`

export const LayoutDataWrp = styled.span`
  position: ${({ position }) => position || 'auto'};
  top: ${({ top }) => top || 'auto'};
  height: ${({ height }) => height || '100%'};
  width: 100%;
`

export const SkeletonWrp = styled.span`
  display: flex;
  width: ${({ width }) => width || '100%'};
  height: ${({ height }) => height || '25rem'};
  max-width: ${({ maxWidth }) => maxWidth || 'unset'};
  ${SCREEN_SIZE.Below.Desktop} {
    height: 20rem;
  }
  ${SCREEN_SIZE.Below.Tablet} {
    height: 15rem;
  }
  ${SCREEN_SIZE.Below.MobileL} {
    height: 13rem;
  }
  ${SCREEN_SIZE.Below.MobileM} {
    height: 11rem;
  }
`
export const ProductCollectionSkeletonWrp = styled.span`
  display: flex;
  width: ${({ width }) => width || '100%'};
  height: ${({ height }) => height.aboveDesktop || '45rem'};
  ${SCREEN_SIZE.Below.Tablet} {
    height: ${({ height }) => height.belowTablet || '36rem'};
    ${StyledSimerItem}:last-child,
    ${StyledSimerItem}:first-child {
      display: none;
    }
  }
  ${SCREEN_SIZE.Below.MobileL} {
    height: ${({ height }) => height.belowMobileL || '31rem'};
  }
`

export const Card = styled.span`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-right: 1rem;
  :first-child {
    margin-left: 1rem;
  }
`
